import { useState } from "react";

import { Lock, Users } from "lucide-react";

import { RoleplaySessionShareModal } from "@/components/pieces/roleplays/sharing/session-share/RoleplaySessionShareModal";
import { Button } from "@/components/ui/button";
import {
  FullRoleplaySession,
  ScenarioRoleplaySession,
} from "@/types/roleplays";

type RoleplaySession = (FullRoleplaySession | ScenarioRoleplaySession) & {
  programs?: FullRoleplaySession["programs"];
  sharedMembers?: FullRoleplaySession["sharedMembers"];
};

interface RoleplaySessionShareProps {
  session: RoleplaySession;
}

export function RoleplaySessionShare({ session }: RoleplaySessionShareProps) {
  const [isOpen, setIsOpen] = useState(false);

  const programs = session.programs || [];
  const sharedMembers = session.sharedMembers || [];
  const isShared = programs.length > 0 || sharedMembers.length > 0;

  return (
    <>
      <Button
        intent="secondary"
        className="h-10"
        onClick={() => {
          setIsOpen(true);
        }}
      >
        {isShared ? <Users /> : <Lock />}
        Share
      </Button>

      <RoleplaySessionShareModal
        session={session}
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
    </>
  );
}
